import { css } from '@emotion/react';
import ScribbleSvg from '../../../assets/svg/scribble-circle.svg';
import Circular13 from '../../../assets/svg/wordDecorations/circular-13.svg';
import Circular21 from '../../../assets/svg/wordDecorations/circular-21.svg';
import Circular10Svg from '../../../assets/svg/wordDecorations/scribble-sharpie-oval-08.svg';
import { colors } from '../../../utils/styleguide';

export const variants = {
  circleOld: {
    imgComponent: ScribbleSvg,
    innerCSS: `
      position: absolute;
      top: -10px;
      left: -3px;
      right: -9px;
      bottom: -14px;
    `,
  },
  circular10: {
    imgComponent: Circular10Svg,
    innerCSS: `
      position: absolute;
      top: -40px;
      left: -10px;
      right: -70px;
      bottom: -40px;
    `,
  },
  circular13: {
    imgComponent: Circular13,
    innerCSS: `
      position: absolute;
      top: -40%;
      left: -50%;
      right: -40%;
      bottom: -60%;
    `,
  },
  circular10Large: {
    imgComponent: Circular10Svg,
    innerCSS: `
      position: absolute;
      top: -10px;
      left: -10px;
      right: -40px;
      bottom: -10px;
    `,
  },
  circular21: {
    imgComponent: Circular21,
    innerCSS: `
      position: absolute;
      top: -50%;
      left: -30%;
      right: -50%;
      bottom: -60%;
    `,
  },
};

export type CircleVariants = keyof typeof variants;

type Props = {
  children?: React.ReactNode;
  circleColor?: string;
  variant?: CircleVariants;
  className?: string;
};

const CircledWord = ({
  variant = 'circleOld',
  children,
  className,
  circleColor = colors.black,
}: Props) => {
  const variantData = variants[variant] || {};
  const ScribbleComponent = variantData.imgComponent;
  return (
    <div
      css={css`
        position: relative;
        display: inline-block;
      `}
      className={className}
    >
      <span
        css={css`
          ${variantData.innerCSS}
        `}
        aria-hidden="true"
      >
        <ScribbleComponent
          css={[
            css`
              width: 100%;
              height: 100%;
              > * {
                fill: ${circleColor};
                stroke: ${circleColor};
                stroke-width: 2px;
              }
            `,
          ]}
        />
      </span>
      {children}
    </div>
  );
};

export default CircledWord;
